import { render } from "./DowntimesTable.vue?vue&type=template&id=100f95ba&scoped=true"
import script from "./DowntimesTable.vue?vue&type=script&lang=js"
export * from "./DowntimesTable.vue?vue&type=script&lang=js"

import "./DowntimesTable.vue?vue&type=style&index=0&id=100f95ba&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-100f95ba"]])

export default __exports__